(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sb-size-guides"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-sb-size-guide]');
    if (trigger) {
      const dialog = document.getElementById('sb-size-guide-' + trigger.dataset.sbSizeGuide);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      dialog.showModal();
      document.body.classList.add('sb-size-guide-open');
      dialog.addEventListener('close', function() {
        document.body.classList.remove('sb-size-guide-open');
        trigger.focus();
      }, {once: true});
    }
    const close = event.target.closest('[data-sb-guide-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('.sb-size-guide-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
